import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { FieldEnum } from '../../../common/FieldEnum';
import { InputField } from '../../../common/SemanticWrapper';

class ResetForm extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.valid !== this.props.valid) {
      this.props.setIsValid(nextProps.valid);
    }
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Field name={FieldEnum.Id} component="input" type="hidden" />
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Field
                name={FieldEnum.Password}
                component={InputField}
                type="password"
                maxLength={30}
                label={'Temp Password'}
                autoFocus={true}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name={FieldEnum.ConfirmPassword}
                component={InputField}
                type="password"
                maxLength={30}
                label={'Confirm Temp Password'}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (!values[FieldEnum.Password]) {
    errors[FieldEnum.Password] = 'Password required';
  }

  if (!values[FieldEnum.Password]) {
    errors[FieldEnum.ConfirmPassword] = 'Confirm Password is required.';
  }

  if (values[FieldEnum.Password] && values[FieldEnum.Password].length < 6) {
    errors[FieldEnum.Password] = 'Password must be at least 6 characters.';
  }

  if (
    values[FieldEnum.ConfirmPassword] &&
    values[FieldEnum.ConfirmPassword].length < 6
  ) {
    errors[FieldEnum.ConfirmPassword] =
      'Confirm Password must be at least 6 characters.';
  }

  if (values[FieldEnum.Password] !== values[FieldEnum.ConfirmPassword]) {
    errors[FieldEnum.ConfirmPassword] = 'The passwords must match.';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: 'UserSetupResetPasswordForm',
})(ResetForm);



// WEBPACK FOOTER //
// ./src/pages/usersetup/components/ResetForm.js